import { z } from 'zod';

import { PrimaryKeySchema } from './utils';

export const TaskTemplateSchema = z.object({
  taskTemplateId: PrimaryKeySchema,
  projectId: PrimaryKeySchema.nullable(),
  title: z.string(),
  titleTemplate: z.string(),
  description: z.string(),
  template: z.string(),
  fields: z.array(
    z.discriminatedUnion('type', [
      z.object({
        name: z.string(),
        title: z.string(),
        description: z.string().nullable(),
        type: z.literal('text'),
        required: z.boolean(),
        default: z.string().nullable(),
        example: z.string().nullable(),
      }),
      z.object({
        name: z.string(),
        title: z.string(),
        description: z.string().nullable(),
        type: z.literal('textarea'),
        required: z.boolean(),
        default: z.string().nullable(),
        example: z.string().nullable(),
      }),
      z.object({
        name: z.string(),
        title: z.string(),
        description: z.string().nullable(),
        type: z.literal('number'),
        required: z.boolean(),
        default: z.number().nullable(),
        example: z.number().nullable(),
      }),
      z.object({
        name: z.string(),
        title: z.string(),
        description: z.string().nullable(),
        type: z.literal('boolean'),
        required: z.boolean(),
        default: z.boolean(),
        example: z.boolean().nullable(),
      }),
    ]),
  ),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TaskTemplate = z.infer<typeof TaskTemplateSchema>;
